import React, { useState, useEffect } from "react";
import { Form, Button, Col } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_URL } from "../../constants/Globals";

const GroupSettings = () => {
  const { groupSlug } = useParams();
  const [groupName, setGroupName] = useState("");
  const [allowedNetworkCount, setAllowedNetworkCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    if (groupSlug) {
      getGroupDetail();
    }
  }, [groupSlug]);

  const getGroupDetail = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/admin/groups/groupDetailBySlug?groupSlug=${groupSlug}`
      );
      if (res.data.status === "Success" && res.data.data) {
        const group = res.data.data;
        setGroupName(group.name);
        setAllowedNetworkCount(group.allowedNetworks || 0);
      } else {
        alert("There is a problem in fetching group detail. Please try again!");
      }
    } catch (err) {
      alert("There is a problem in fetching group detail. Please try again!");
      console.error(err);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const payload = {
        groupSlug,
        allowedNetworks: Number(allowedNetworkCount) || 0,
      };

      const response = await axios.put(
        `${API_URL}/admin/groups/updateGroupSettings`,
        payload
      );

      if (response.data.status === "success") {
        setSuccessMsg("Settings updated successfully.");
      } else {
        console.error("Unexpected response:", response.data);
        alert("Failed to update settings. Please try again.");
      }

      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      console.error("Error saving settings", err);
      alert("Error saving settings. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={loading ? "loading" : ""}>
      {successMsg && <div className="sucessMsg">{successMsg}</div>}

      <div className="page-headline is-flex">
        <div>
          <strong>Organization Settings</strong> &nbsp;|&nbsp; {groupName}
        </div>
        <div className="buttons">
          <Button onClick={handleSave} className="btn btn-primary">
            Save Settings
          </Button>
        </div>
      </div>

      <Form className="WLSettings common-form row">
        <Col md={6} className="pe-4">
          <Form.Group controlId="allowedNetworkCount">
            <Form.Label>Allowed Networks Count</Form.Label>
            <Form.Control
              type="number"
              value={allowedNetworkCount}
              onChange={(e) => setAllowedNetworkCount(e.target.value)}
              placeholder="Enter max allowed networks"
              min="0"
            />
          </Form.Group>
        </Col>
      </Form>
    </section>
  );
};

export default GroupSettings;
